module.exports = __webpack_public_path__ + "static/img/routedes3.f0a8c72.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/routedes3.png
// module id = J7PS
// module chunks = 0